import { ModuleFeature } from 'features/Modules';

export const SharedContentModuleFeature: React.FC<Content.SharedContentModule> = ({ content }) => {
	const { modules } = content?.properties?.content?.properties ?? {};
	return <>{modules && modules.map((module, index) => <ModuleFeature contentModule={module} key={index} />)}</>;
};
